// test2299
(2299 && 0);
